import { ChangeDetectionStrategy, Component, effect, ElementRef, inject, signal, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RegisterUserService } from 'src/app/pages/register-user/services';
import { TranslationService } from 'src/app/services/translation.service';
import Swiper, { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-loader-carousel-swiper',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './loader-carousel-swiper.component.html',
  styleUrls: ['./loader-carousel-swiper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderCarouselSwiperComponent {
  public swiperRef = viewChild<ElementRef>('swiper');
  
  private _registerUserService = inject(RegisterUserService);
  private _translationService = inject(TranslationService);

  public images = [
        'https://estaticos.esmadrid.com/cdn/farfuture/Cdv2G-CVfvJNa-H_aa9th5X8XE8NU88hLZHjecgWiA8/mtime:1744010134/sites/default/files/eventos/eventos/flamboyant._joana_vasconcelos.jpg',
        'https://estaticos.esmadrid.com/cdn/farfuture/hFm1xAczvPP4ftC9IldkOzVsk7_upgdDRHT5xDHmjho/mtime:1487808257/sites/default/files/agenda/eventos/MuseoArteContemporaneo_1430997045.777.jpg',
        'https://estaticos.esmadrid.com/cdn/farfuture/v46ai1S3gXsfq7HgUQz-dIzroQY03zsWaDS75FewGXQ/mtime:1740749056/sites/default/files/eventos/eventos/centenario_cuesta_de_moyano.jpeg',
        'https://estaticos.esmadrid.com/cdn/farfuture/ibn3Wv0Xxu-GC97iQ0dY4HCkQhMCY1p8muoPPdRuBj0/mtime:1605614161/sites/default/files/eventos/eventos/julia_de_jaume_plensa_2.jpg',
        'https://estaticos.esmadrid.com/cdn/farfuture/kNnHPAQ5jKw95Ge70OzwFWaeAyhqc7DOhJJQ5YlgKVM/mtime:1734341336/sites/default/files/eventos/eventos/tren_juan_carlos_i.jpg',
        'https://estaticos.esmadrid.com/cdn/farfuture/DsLZfLEPzt3rvnmMNgpEBGmmVZhZ8j5zDPdE1B9ACdg/mtime:1540890047/sites/default/files/eventos/eventos/trenes.jpg'
    ];
  
  //protected carouselImgList = this._registerUserService.carouselMultimedia;
  protected registerUser = this._registerUserService.registerUser;
  private _selectedLanguage = this._translationService.selectedLanguage
  
  private _isDomReady = signal<boolean>(false);
  
  private _swiperInstance!: Swiper;  
  public delayTransition: number = 5000;
  
  // ✅ Variables para controlar el ciclo de pausas
  private _slideCount = 0;
  private _pauseTimeout: any;
  private _isOnPause = false;
  
  setSWiper = effect(() => {
    if(!this._isDomReady() || !this.swiperRef()) return;
    
    const swiperEl = this.swiperRef().nativeElement;
    if(!swiperEl) return;

    if (this._swiperInstance) {
      this._swiperInstance.destroy(true, true);
    }
    
    const swiperConfig: SwiperOptions = {
      slidesPerView: 3,
      centeredSlides: true,
      centeredSlidesBounds: true, 
      spaceBetween: 0,
      grabCursor: false,
      allowTouchMove: false,
      autoplay: {
        delay: 1000,        
        disableOnInteraction: false,
      },
      loop: true,
      slidesOffsetBefore: -40,
      slidesOffsetAfter: -40,
      on: {
        slideChange: () => {
          this.handleSlideChange();
        }
      }
    }
    
    this._swiperInstance = new Swiper(swiperEl, swiperConfig);
  }, { allowSignalWrites: true });

  private handleSlideChange(): void {
    if (this._isOnPause) return; // No contar slides durante la pausa
    
    this._slideCount++;
    
    // Cada 3 slides, hacer una pausa de 3 segundos
    if (this._slideCount >= 3) {
      this.pauseAutoplay();
    }
  }

  private pauseAutoplay(): void {
    if (!this._swiperInstance?.autoplay) return;
    
    this._isOnPause = true;
    this._slideCount = 0; // Resetear contador
    
    this._swiperInstance.autoplay.stop();
    
    this._pauseTimeout = setTimeout(() => {
      this.resumeAutoplay();
    }, 3000);
  }

  private resumeAutoplay(): void {
    if (!this._swiperInstance?.autoplay) return;
    this._isOnPause = false;
    this._swiperInstance.autoplay.start();
  }
  
  protected getPointLoaderName(srcImg: string): string {
    const registerUser = this.registerUser();
    if (!registerUser) return '';
    
    const pointListLoader = registerUser.pointListLoader;
    if (!pointListLoader) return '';
    
    const loader = pointListLoader.find(loader => loader.src === srcImg);
    if (!loader) return '';
    
    const name = loader.name;
    const lang = this._selectedLanguage();
    return name[lang] || name['en'] || '';
  }
  
  protected getListOfImages(): string[] {
    if (this.isPointListLoader()) {
      const pointListLoader = this.registerUser().pointListLoader;
      if (!pointListLoader) return this.images;
      
      return pointListLoader.map(loader => loader.src);
    }
    
    return this.images;
  }
  
  protected isPointListLoader(): boolean {
    const registerUser = this.registerUser();
    const pointListLoader = registerUser?.pointListLoader;
    if(!registerUser || !pointListLoader) return false;
    
    return pointListLoader.length > 0;
  }
  
  ngAfterViewInit(){
    this._isDomReady.set(true);
    
    console.log('registerUser in loader-carousel:', this.registerUser());
  }

  ngOnDestroy(): void {
    if (this._pauseTimeout) {
      clearTimeout(this._pauseTimeout);
    }
    
    if (this._swiperInstance) {
      this._swiperInstance.destroy(true, true);
    }
  }
}
